import { faSignOut } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useContext } from 'react';

import AppContext from '@/contexts/appContext';

const Logout = () => {
  const { setCurrentUser, host } = useContext(AppContext);
  const handleLogout = () => {
    setCurrentUser(null);

    // Remove the host from the local storage
    const storedUser = localStorage.getItem('dugoutCurrentUser');
    if (storedUser) {
      const hostUsers = JSON.parse(storedUser);
      delete hostUsers[host];
      localStorage.setItem('dugoutCurrentUser', JSON.stringify(hostUsers));
    }
  };

  return (
    <button className="flex" onClick={handleLogout}>
      <FontAwesomeIcon className="mr-2" icon={faSignOut} />
      Logout
    </button>
  );
};

export default Logout;
